export enum SignUpProgressEnum {
  CreateAccount = 0,
  PharmacyDetails = 1,
  SetPIN = 2,
}
